module.exports = __webpack_public_path__ + "img/BCI.dbfe7f79.jpg";